import { render, staticRenderFns } from "./PAtencion.vue?vue&type=template&id=2aba1bae"
import script from "./PAtencion.vue?vue&type=script&lang=ts"
export * from "./PAtencion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports